module.exports = __webpack_public_path__ + "img/ai_letterM.52cbd7e9.png";